// src/features/universalsearcher/appinfoSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  appointmentInfo: {}, // Initialize as an empty object
};

const appinfoSlice = createSlice({
  name: 'appinfo', // Slice name
  initialState,
  reducers: {
    setAppointmentInfo: (state, action) => {
      // Merge new appointment info into the existing object
      state.appointmentInfo = { ...state.appointmentInfo, ...action.payload };
    },
    deleteAppointmentInfo: (state, action) => {
      const { key } = action.payload;
      if (key in state.appointmentInfo) {
        delete state.appointmentInfo[key]; // Remove the object by key
      }
    },
    resetAppointmentInfo: (state) => {
      state.appointmentInfo = {}; // Reset to an empty object
    },
  },
});

// Export actions
export const { setAppointmentInfo, deleteAppointmentInfo, resetAppointmentInfo } = appinfoSlice.actions;

// Export reducer
export default appinfoSlice.reducer;
